import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { useOkapiKy } from '@folio/stripes/core';
import { fetchProposalTabCounts } from '../api/proposalService';
import { foldProposalCountsByTab } from '../types/api';
import useAuthorizationContext from './useAuthorizationContext';
import { PROPOSALS_QUERY_ROOT } from './useProposalList';
/**
 * CZNA-973: personal work counts shown beside the authority workspace buttons.
 *
 * One aggregate request supplies the number; the returned-work count moved to the Inbox
 * (CZNA-1446). Its key lives below the proposal query root so saving, submitting or
 * reviewing a proposal refreshes the badge through the same invalidation already used by
 * the proposal lists.
 */
var useAuthorityWorkspaceCounts = function () {
    var ky = useOkapiKy();
    var context = useAuthorizationContext().context;
    var userId = context === null || context === void 0 ? void 0 : context.userId;
    var ownership = userId ? { createdBy: userId } : null;
    var proposalCounts = useQuery([PROPOSALS_QUERY_ROOT, 'counts', ownership], function () { return fetchProposalTabCounts(ky, ownership !== null && ownership !== void 0 ? ownership : {}); }, {
        enabled: ownership !== null,
        keepPreviousData: true,
        staleTime: 30000,
    }).data;
    return useMemo(function () {
        var _a;
        var counts = Array.isArray(proposalCounts)
            ? foldProposalCountsByTab(proposalCounts)
            : null;
        return {
            myDrafts: (_a = counts === null || counts === void 0 ? void 0 : counts.DRAFT) !== null && _a !== void 0 ? _a : null,
        };
    }, [proposalCounts]);
};
export default useAuthorityWorkspaceCounts;
